// CompanyLogo — extrahiert aus app/src/components/editor/Viewer/CompanyLogo.tsx
// (Plan A Mapping-Audit 2026-05-22).
//
// Shows org branding logo in the viewer.
// Priority: per-template companyLogoUrl (legacy) > org branding logo (new system).
//
// position:fixed Variante (Viewport-edge). public/-Stack hat eine eigene
// chromeOverlays-Variante mit position:absolute (siehe
// public/src/components/viewer/CompanyLogo.tsx) — die bleibt public-only.

import type { PostJson } from "@scrolly/post-types";

export interface BrandingLogo {
  url: string;
  position: string; // 'left' | 'center' | 'right' | 'none' | 'hidden'
}

interface Props {
  post: PostJson;
  brandingLogo?: BrandingLogo | null;
}

export function CompanyLogo({ post, brandingLogo }: Props) {
  const slideOptions = post.data.data.presentationOptions.slideOptions;
  const { companyLogoPosition, companyLogoUrl } = slideOptions;

  // „Aus" am Scrolly gewinnt ueber das Org-Branding — gleiche Regel wie im
  // public/-Viewer (CompanyLogo dort, Jans iPhone-Befund 07.09.2026). Eine
  // am Scrolly gesetzte Position gewinnt ebenfalls ueber die der Org.
  if (companyLogoPosition === "none") {
    return null;
  }

  let logoUrl: string | undefined;
  let logoPosition: string | undefined;

  if (companyLogoUrl) {
    logoUrl = companyLogoUrl;
    logoPosition = companyLogoPosition;
  } else if (brandingLogo?.url) {
    logoUrl = brandingLogo.url;
    logoPosition = companyLogoPosition || brandingLogo.position;
  }

  if (!logoUrl || logoPosition === "none" || logoPosition === "hidden") {
    return null;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        display: "flex",
        width: "100%",
        overflow: "hidden",
        scrollbarGutter: "stable",
        justifyContent:
          logoPosition === "center" ? "center" : "flex-start",
        pointerEvents: "none",
      }}
    >
      <div
        style={{ margin: "12px 16px", height: 40, pointerEvents: "auto" }}
      >
        <img
          style={{
            height: "100%",
            width: "auto",
            objectFit: "contain",
            display: "block",
          }}
          src={logoUrl}
          alt="Logo"
        />
      </div>
    </div>
  );
}
